import { ButtonLink } from "ui/components/Button/ButtonLink";
import { transformRoute, useTranslate } from "helpers";
import { Routes as FleetVehicleRoutes } from "ui/modules/fleet/vehicles/navigation";
import { VehicleOfferHeaderProps } from "./types";

const VehicleOfferHeader = ({
    vehicleId,
    onAdd,
}: VehicleOfferHeaderProps) => {
    const { t } = useTranslate();

    return (
        <div className="flex items-center gap-2">


            <ButtonLink
                size="small"
                variant="warning"
                children="Pregled"
                to={transformRoute(
                    FleetVehicleRoutes.FleetVehicleOfferSearchPageRouter,
                    {
                        id: vehicleId,
                    }
                )}
                startIcon="/media/icons/search.svg"
            />

        </div>
    );
};

export default VehicleOfferHeader;
